import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSimple = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Shaping Tomorrow's Digital Ecosystems",
      subtitle: "Shaping tomorrow's digital ecosystems, empowered by AI and human intelligence.",
      button: "Explore Our Services",
      image: "/assets/01.png",
      color: "bg-[#D81B60]",
      link: "/development"
    },
    {
      id: 2,
      title: "AI-Driven Innovation",
      subtitle: "Empowering businesses through AI-driven, human-focused innovation.",
      button: "Discover Solutions",
      image: "/assets/02.png",
      color: "bg-blue-600",
      link: "/services/ai"
    },
    {
      id: 3,
      title: "Advanced Cloud Infrastructure",
      subtitle: "Scale your business with our AWS Advanced Tier certified cloud engineering and managed services.",
      button: "Explore Cloud Solutions",
      image: "/assets/Home1.png",
      color: "bg-[#FF9900]",
      position: "bg-right-top",
      link: "/services"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative h-[600px] w-full bg-gray-900 overflow-hidden group">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          className="absolute inset-0"
        >
          {/* Background Image */}
          <div
            className={`absolute inset-0 bg-cover ${slides[currentSlide].position || 'bg-center'} bg-no-repeat transform hover:scale-105 transition-transform duration-[10s]`}
            style={{ 
              backgroundImage: `url(${slides[currentSlide].image})`,
              transformOrigin: slides[currentSlide].id === 3 ? 'top right' : 'center'
            }}
          />
          {/* Gradient Overlay for Text Readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>

          {/* Content */}
          <div className="absolute inset-0 flex items-center">
            <div className="container mx-auto px-6 relative">
              <div className="flex flex-col md:flex-row items-center justify-between gap-12">
                <div className="max-w-3xl text-white">
                  <motion.h2
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="text-5xl md:text-6xl font-bold mb-6 leading-tight"
                  >
                    {slides[currentSlide].title}
                  </motion.h2>

                  <motion.p
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    className="text-xl mb-8 text-gray-200 leading-relaxed max-w-2xl"
                  >
                    {slides[currentSlide].subtitle}
                  </motion.p>

                  <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.4 }}
                  >
                    <Link
                      to={slides[currentSlide].link}
                      className={`inline-block px-8 py-4 rounded-full font-bold text-white transition-all transform hover:scale-105 shadow-lg ${slides[currentSlide].color}`}
                    >
                      {slides[currentSlide].button}
                    </Link>
                  </motion.div>
                </div>

                {/* Badge for Slide 3 */}
                {slides[currentSlide].id === 3 && (
                  <motion.div
                    initial={{ scale: 0.8, opacity: 0, x: 50 }}
                    animate={{ scale: 1, opacity: 1, x: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="flex-shrink-0"
                  >
                    <div className="p-4 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 shadow-2xl">
                      <img 
                        src="/assets/AWS-Partner-Advanced-Tier-Services 1 (1) (1).jpg" 
                        alt="AWS Advanced Tier Partner" 
                        className="h-32 md:h-48 w-auto object-contain rounded-xl"
                      />
                    </div>
                  </motion.div>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Progress Indicators */}
      <div className="absolute bottom-10 left-0 w-full z-20">
        <div className="container mx-auto px-6 flex items-center gap-4">
          <span className="text-sm font-medium text-white/80 hidden md:block">Highlights</span>
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className="h-[2px] flex-1 max-w-[100px] bg-white/30 rounded-full overflow-hidden transition-all hover:h-[4px]"
            >
              <div
                className={`h-full bg-white transition-all duration-[5000ms] ease-linear ${index === currentSlide ? 'w-full' : 'w-0'}`}
              ></div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSimple;